import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";
import WrongLocationIcon from "@mui/icons-material/WrongLocation";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import { clearRoute } from "../../../redux/slice/routeSlice";
import toast from "react-hot-toast";

const MenuActionsMap = ({ handleOpen }) => {
  const { status } = useSelector((state) => state.userReducer);
  const { membershipStatus } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const handleClearRoute = () => {
    // console.log("Borar ruta");
    dispatch(clearRoute());
  };
  return (
    <Box
      sx={{
        position: "absolute",
        right: 20,
        bottom: 100,
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Tooltip title={"Borrar Ruta"}>
        <IconButton
          style={{
            backgroundColor: "#e7ef7d",
            borderRadius: 50,
            boxShadow: "0px 1px 15px 2px rgba(0,0,0,1)",
            margin: "0px 10px ",
            transform: "scale(0.9)",
          }}
          onClick={handleClearRoute}
          // size={button.action === buttonSelected ? "medium" : "small"}
        >
          <WrongLocationIcon style={{ color: "black" }} />
        </IconButton>
      </Tooltip>
      <Tooltip title={"Guardar Ruta"}>
        <IconButton
          style={{
            backgroundColor: "#e7ef7d",
            borderRadius: 50,
            boxShadow: "0px 1px 15px 2px rgba(0,0,0,1)",
            margin: "0px 10px ",
            transform: "scale(0.9)",
          }}
          onClick={() => {
            if (status === "active" || membershipStatus === "active") {
              handleOpen();
            } else {
              toast.error(
                `Su cuenta no esta completa. \n Para poder crear una ruta complete su cuenta.`
              );
            }
          }}
          // size={button.action === buttonSelected ? "medium" : "small"}
        >
          <SaveIcon style={{ color: "black" }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default MenuActionsMap;
